import { cn } from '@finn/ui-utils';
import React, { useMemo } from 'react';

import { ArticleCard } from './ArticleCard';
import { RelatedArticlesMetadata } from './meta';

type Props = {
  data: RelatedArticlesMetadata & { allTagsData: any };
};

export const RelatedArticles: React.FC<Props> = ({ data }) => {
  const relatedArticles = useMemo(() => {
    const pageTags = data.pageTags?.map((item) => ({
      slug: item.slug,
    }));

    const sameTagArticles = pageTags
      ?.map((item) => {
        const articleByTags = data.allTagsData?.pagesByTags?.[item.slug];

        return articleByTags;
      })
      .flat()
      .sort(
        (a, b) =>
          new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
      )
      .slice(0, 3 - Math.min(3, data.recommendedArticles.length));

    return sameTagArticles;
  }, [data.recommendedArticles.length, data.pageTags]);

  return (
    <div className="container my-8">
      {data?.metadata?.title && (
        <h2 className="mb-8 mobile-t4-semibold md:web-t4-semibold">
          {data.metadata.title}
        </h2>
      )}
      <div
        className={cn(
          'mt-6 grid w-full grid-cols-[minmax(343px,1fr)] gap-x-6 gap-y-10 sm:grid-cols-[repeat(2,minmax(343px,1fr))] md:grid-cols-[repeat(3,minmax(343px,1fr))]'
        )}
      >
        {[...data.recommendedArticles, ...(relatedArticles ?? [])].map(
          (article) => (
            <ArticleCard key={article.slug} article={article} />
          )
        )}
      </div>
    </div>
  );
};
